import { MOBILE_E164_PATTERN, normalizeCodeInput, normalizeMobileField } from '@saay/formatting';

import type { MerchantFilters } from './queries.js';

const SEARCH_MIN_NAME = 3;

/** Maps the merchant search box to `listAdminMerchants` query params (ADM-11). */
export function merchantSearchFromText(
  raw: string,
):
  | { readonly filters: Pick<MerchantFilters, 'contactMobileE164' | 'q'> }
  | { readonly message: string } {
  const trimmed = raw.trim();
  if (trimmed === '') {
    return { filters: {} };
  }
  const digits = normalizeCodeInput(trimmed).replace(/\D/g, '');
  const nonIdentifierChars = trimmed.replace(/[0-9۰-۹٠-٩\s\u200c./-]/g, '');
  const looksLikeIdentifier = digits.length > 0 && nonIdentifierChars.length === 0;
  if (!looksLikeIdentifier && /[A-Za-z\u0600-\u06FF]/.test(trimmed)) {
    if (trimmed.length < SEARCH_MIN_NAME) {
      return { message: 'برای جست‌وجو دست‌کم ۳ حرف وارد کنید.' };
    }
    return { filters: { q: trimmed } };
  }
  if (digits.length > 0) {
    if (/^09\d{9}$/.test(digits)) {
      const contactMobileE164 = normalizeMobileField(digits);
      if (!MOBILE_E164_PATTERN.test(contactMobileE164)) {
        return { message: 'شماره موبایل معتبر نیست.' };
      }
      return { filters: { contactMobileE164 } };
    }
    if (/^\d{10}$/.test(digits)) {
      return { filters: { q: digits } };
    }
    return { message: 'برای موبایل ۱۱ رقم با ۰۹ یا شناسهٔ ملی ۱۰ رقم وارد کنید.' };
  }
  return { message: 'برای جست‌وجو دست‌کم ۳ حرف وارد کنید.' };
}
